import { DISPLAY_ERROR_MESSAGE, RESET_MODEL_AND_ERROR_FLAGS, SET_LOADING_FALSE, FETCH_DATE_CONFIG, 
        SET_FROM_DATE, SET_UNTIL_DATE, SET_IS_VALID_DATERANGE } from './actionTypes';

export const calendarReducer = (state, action) => {
    switch(action.type) {
        case FETCH_DATE_CONFIG : 
            return {
                ...state,
                fromMinDate: action.payload.fromMinDate,
                fromRevenueDate: action.payload.fromRevenueDate,
                fromMaxDate: action.payload.fromMaxDate,
                untilMinDate: action.payload.untilMinDate,
                untilRevenueDate: action.payload.untilRevenueDate,
                untilMaxDate: action.payload.untilMaxDate,
                sessionTimeoutLimit: action.payload.sessionTimeoutLimit,
                idleTimeoutLimit: action.payload.idleTimeoutLimit
            }
        case SET_FROM_DATE:
            return {
                ...state,
                fromRevenueDate: action.payload.fromRevenueDate,
                isError: false,
                errorMessage: ""
            };
        case SET_UNTIL_DATE:
            return {
                ...state,
                untilRevenueDate: action.payload.untilRevenueDate,
                isError: false,
                errorMessage: ""
            };    
        case SET_IS_VALID_DATERANGE:
            return {
                ...state,
                isValidDateRange: action.payload.isValid
            }    
        case DISPLAY_ERROR_MESSAGE : 
            return {
                ...state,
                isError: action.payload.isError,
                errorMessage: action.payload.errorMessage,
                showModel: action.payload.showModel,
                modelHeaderTitle: action.payload.modelHeaderTitle,               
                isLoading: false
            }  
        case RESET_MODEL_AND_ERROR_FLAGS :  
            return {
                ...state,
                isError: false, 
                errorMessage: "", 
                showModel: false,
                modelHeaderTitle: "",
                isLoading: false                                         
            }
        case SET_LOADING_FALSE:
            return {
                ...state,
                isLoading: action.payload.isLoading                            
            } 
        default : 
            return state;   
    }
}
